import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup, Form, Message, Divider } from 'semantic-ui-react';
import { compose } from 'recompose';
import _ from 'lodash';
import validator from 'validator';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

const getFilter = ids => {
  if (_.size(ids)) {
    return {
      filter: {
        influencer: _.join(ids, ','),
      },
      include: ['influencer'],
    };
  }
  return {
    include: ['influencer'],
  };
};

const errorStyle = {
  color: '#9f3a38',
  fontSize: 12,
};

const dividerStyle = {
  margin: '5px 0',
};


const getErrorMessage = (
  influencerAlreadyExists,
  sameEmailAsLoggedInUser,
  userAlreadyInOrganisation,
  emailIsValid,
  email,
) => {
  if (influencerAlreadyExists) {
    return 'An influencer from your database is already using this email address.';
  }
  if (sameEmailAsLoggedInUser) {
    return `You cannot use your own email to log in as an influencer. You are logged in as ${email}`;
  }
  if (userAlreadyInOrganisation) {
    return 'Someone in your organisation is already using this email address.';
  }
  if (emailIsValid) {
    return 'This email address is invalid.';
  }
  return 'Invalid email';
};

class ValidatedEmailField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || null,
      isLoading: false,
      isValid: true,
      errorMessage: '',
    };
  }

  onChange = (event, { value }) => {
    this.setState({
      value,
    });
  }

  onBlur = () => {
    const { value } = this.state;
    const { userInfo, jsonAPIClient, onStateChanged } = this.props;
    if (_.isEmpty(value)) {
      this.setState({
        isValid: true,
        errorMessage: null,
        isLoading: false,
      }, () => onStateChanged(true, value));
    } else {
      this.setState({
        isLoading: true,
      }, () => {
        onStateChanged(false, value);
        const { email, organisationId } = userInfo;

        jsonAPIClient.find('users', {
          filter: {
            organisation: organisationId,
          },
        }, (error, response) => {
          const userEmails = _.map(response, item => item.get('email'));
          jsonAPIClient.find('influencer', {
            filter: {
              email: value,
            },
          }, (err, res) => {
            const influencerIDS = _.size(res) > 0 ? _.map(res, item => item.toJSON().id) : []; // 66
            jsonAPIClient.find('influencerLink', getFilter(influencerIDS), (err, links) => {
              const records = _.map(links, link => link.toJSONTree());

              const influencerAlreadyExists = !_.isUndefined(_.find(records, record => {
                const { influencer: { email: influencerEmail }, organisation } = record;
                return influencerEmail === value && organisation.id === organisationId;
              }));

              const sameEmailAsLoggedInUser = email === value;
              const userAlreadyInOrganisation = _.includes(userEmails, value);
              const emailIsValid = validator.isEmail(value);
              const isValid = emailIsValid && !influencerAlreadyExists && !sameEmailAsLoggedInUser && !userAlreadyInOrganisation;
              const message = getErrorMessage(
                influencerAlreadyExists,
                sameEmailAsLoggedInUser,
                userAlreadyInOrganisation,
                emailIsValid,
                email,
              );

              this.setState({
                isValid,
                errorMessage: message,
                isLoading: false,
              }, () => onStateChanged(isValid, value));
            });
          });
        });
      });
    }
  }

  render() {
    const { value, isValid, isLoading, errorMessage } = this.state;
    const { readOnly, hasLabel, fluid, required } = this.props;
    return (
      <Popup
        position="right center"
        open={!isValid} trigger={
          <Form.Input
            width={fluid ? 16 : 12}
            fluid={fluid}
            readOnly={readOnly}
            onChange={this.onChange}
            onBlur={this.onBlur}
            error={!isValid}
            loading={isLoading}
            disabled={isLoading}
            label={hasLabel ? 'Email' : ''}
            value={value}
            required={required}
            onKeyPress={e => { e.key === 'Enter' && e.preventDefault(); }}
          />
        }
        content={
          <div style={errorStyle}>
            <h3>Invalid e-mail</h3>
            <Divider fitted style={dividerStyle} />
            { errorMessage }
          </div>
        }
      />

    );
  }
}

ValidatedEmailField.propTypes = {
  value: PropTypes.any,
  userInfo: PropTypes.object.isRequired,
  jsonAPIClient: PropTypes.func.isRequired,
  onStateChanged: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  hasLabel: PropTypes.bool.isRequired,
  fluid: PropTypes.bool.isRequired,
};

ValidatedEmailField.defaultProps = {
  readOnly: false,
  hasLabel: true,
  value: null,
  fluid: false,
};

export default compose(
  hasUserInfo,
  hasJSONAPIClient,
)(ValidatedEmailField);



/** WEBPACK FOOTER **
 ** ./src/components/validated-email-field/index.js
 **/